import { render } from "./button.html?vue&type=template&id=7132a7c1"
import script from "./button.js?vue&type=script&lang=js"
export * from "./button.js?vue&type=script&lang=js"

import "./button.less?vue&type=style&index=0&lang=less"

import exportComponent from "/Users/vito.degioia/Documents/Projects/mb-fiori-2023/fiori-del-mulino/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__